























































































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Api from "@/api";
import swal from "sweetalert";
import { AxiosResponse } from "axios";

import NavigationTabs from "@/components/Settings/Events/EventDetails/NavigationTabs.vue";
import ViewLoader from "@/components/Common/ViewLoader.vue";
import AlertBox from "@/components/Common/Alerts/AlertBox.vue";
import Error404 from "@/components/Common/Error404.vue";
import { IAppointment, IEvent } from "@/interface";

Component.registerHooks(["beforeRouteEnter", "beforeRouteUpdate"]);

@Component({
  components: {
    ViewLoader,
    NavigationTabs,
    AlertBox,
    Error404
  }
})
export default class EventAppointments extends Vue {
  public loading = false;
  public updating = false;
  private eventAppointments: Array<IAppointment> = [];
  private noDataExist = false;
  private eventAppointmentsLength = 0;
  private searchFilter = "";
  private failedRequest = false;
  private currentPage = 1;
  private total = 0;
  private from = 0;
  private to = 0;
  private firstPage = 1;
  private lastPage: number | null = null;
  private perPage: number | null = null;
  private selectedEvent: IEvent | null = null;
  private selectedEventId: string | null = null;
  private componentKey = 0;

  private beforeRouteEnter(to: any, from: any, next: any): void {
    next((vm: this) => {
      vm.selectedEventId = vm.$route.params.event_id;

      if (vm.$route.query.event_appointment_deleted === "true") {
        swal("Success!", "The appointment was deleted.", "success").then(() => {
          window.history.pushState(
            {},
            document.title,
            window.location.pathname
          );
        });
      }
      vm.getEventAppointments(() => {
        //
      });
      vm.getEvent(() => {
        //
      });
    });
  }

  private beforeRouteUpdate(to: any, from: any, next: any): void {
    if (to.query.event_appointment_deleted === "true") {
      swal("Success!", "The appointment was deleted.", "success").then(() => {
        window.history.pushState({}, document.title, window.location.pathname);
      });
    }
    this.forceRerender();
    if (
      this.perPage !== null &&
      this.to % this.perPage === 1 &&
      this.currentPage !== 1
    ) {
      this.currentPage -= 1;
    }
    this.getEventAppointments(() => {
      //
    });
    this.getEvent(() => {
      //
    });
    next();
  }

  private getEvent(successCallback?: any): void {
    this.loading = true;
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId
    );

    Api()
      .get(endpoint)
      .then((response: AxiosResponse) => {
        this.selectedEvent = response.data.data;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch((error: any) => {
        if (error.response.status === 404) {
          this.noDataExist = true;
        }
        console.log(error.response);
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private getEventAppointments(successCallback: any): void {
    if (this.loading) {
      return;
    }

    this.loading = true;
    this.eventAppointments = [];
    const endpoint: string = this.$partnerEndpoint(
      "events/" + this.selectedEventId + "/appointments"
    );

    Api()
      .get(endpoint, {
        params: {
          page: this.currentPage,
          search: this.searchFilter
        }
      })
      .then((response: AxiosResponse) => {
        this.eventAppointments = response.data.data;
        this.currentPage = response.data.meta.current_page;
        this.total = response.data.meta.total;
        if (response.data.meta.from != null) {
          this.from = response.data.meta.from;
        } else {
          this.from = 0;
        }
        if (response.data.meta.to != null) {
          this.to = response.data.meta.to;
        } else {
          this.to = 0;
        }
        this.lastPage = response.data.meta.last_page;
        this.perPage = response.data.meta.per_page;
        this.eventAppointmentsLength = response.data.data.length;
        this.failedRequest = false;
        if (typeof successCallback == "function") {
          successCallback();
        }
      })
      .catch(() => {
        this.failedRequest = true;
      })
      .finally(() => {
        this.loading = false;
      });
  }

  private deleteEventAppointment(appointmentId: number): void {
    if (this.loading || this.updating || appointmentId == null) {
      return;
    }

    swal({
      title: "Are you sure?",
      text: "The appointment will be deleted and will not be able to use it",
      icon: "warning",
      dangerMode: true,
      buttons: {
        cancel: {
          visible: true,
          text: "Cancel",
          closeModal: true
        },
        confirm: {
          visible: true,
          text: "Yes, delete it!",
          closeModal: true
        }
      }
    }).then(isConfirm => {
      if (isConfirm) {
        const endpoint = this.$partnerEndpoint(
          "events/" + this.selectedEventId + "/appointments/" + appointmentId
        );

        Api()
          .delete(endpoint)
          .then(() => {
            this.$router
              .push({
                name: "EventAppointments",
                query: { event_appointment_deleted: "true" }
              })
              .catch((error: any) => {
                console.log(error);
                if (
                  error.name === "NavigationDuplicated" ||
                  error.message.includes(
                    "Avoided redundant navigation to current location"
                  )
                ) {
                  swal("Success!", "The appointment was deleted.", "success");
                  this.getEventAppointments(() => {
                    //
                  });
                }
              });
          })
          .catch((error: any) => {
            if (error.response.status === 403) {
              swal({
                title: "Missing permission",
                text: "You are not allowed to delete event appointments.",
                icon: "error"
                //dangerMode: true,
              });
            }
          });
      } else {
        //
      }
    });
  }

  private goToFirstPage(): void {
    if (!this.disabledFirstPage) {
      this.currentPage = 1;
      this.getEventAppointments(() => {
        //
      });
    }
  }

  private goToPreviousPage(): void {
    if (!this.disabledPreviousPage) {
      this.currentPage--;
      this.getEventAppointments(() => {
        //
      });
    }
  }

  private goToNextPage(): void {
    if (!this.disabledNextPage) {
      this.currentPage++;
      this.getEventAppointments(() => {
        //
      });
    }
  }

  private goToLastPage(): void {
    if (!this.disabledLastPage && this.lastPage !== null) {
      this.currentPage = this.lastPage;
      this.getEventAppointments(() => {
        //
      });
    }
  }

  private forceRerender(): void {
    this.componentKey += 1;
  }

  get disabledFirstPage(): boolean {
    return this.currentPage === 1;
  }

  get disabledPreviousPage(): boolean {
    return this.currentPage === 1;
  }

  get disabledNextPage(): boolean {
    return this.currentPage === this.lastPage;
  }

  get disabledLastPage(): boolean {
    return this.currentPage === this.lastPage;
  }

  @Watch("perPage")
  perPageChanged(): void {
    this.getEventAppointments(() => {
      //
    });
  }

  @Watch("searchFilter")
  searchFilterChanged(): void {
    this.getEventAppointments(() => {
      //
    });
  }
}
